export default "__VITE_ASSET__CaWcwInN__"